<form
  *ngIf="formConfig || formFields"
  [formGroup]="form"
  class="form-container--formly"
  (ngSubmit)="onSubmit(model)"
>
  <formly-form
    [form]="form"
    [fields]="fieldsFormly"
    [model]="model"
    (modelChange)="onModelChange($event)"
  ></formly-form>

  <div
    class="form-container--formly__buttons"
    [class.form-container--formly__buttons--space-between]="
      buttons && buttons.length > 1
    "
  >
    <p-button
      *ngFor="let button of buttons"
      (click)="onActionButton(button)"
      [label]="
        button.translate ? (button.label || '' | translate) : button.label
      "
      [icon]="button.icon"
      [type]="button.type"
      [severity]="button.severity"
    ></p-button>
    <!-- <p-button type="submit" label="Submit"></p-button> -->
  </div>
</form>
